import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { Tournament, TournamentPrize2, TournamentPrizes, TournamentPrizes2 } from "../../../../../shared/models";
import { User } from "../../../../../shared/models/user";
import { inject } from "@angular/core/testing";
import { ManagerService } from "../../../../../core/services/manager.service";
import { shareReplay, switchMap } from "rxjs/operators";
import { v3ManagerService } from "../../../../../core/services/v3-manager.service";

@Component({
  selector: "app-view-tournament-mobile-payouts",
  templateUrl: "./view-tournament-mobile-payouts.component.html",
  styleUrls: ["./view-tournament-mobile-payouts.component.scss"],
})
export class ViewTournamentMobilePayoutsComponent implements OnInit, OnChanges {
  @Input() tournament: Tournament;
  @Input() user: User;
  prizesData: TournamentPrizes2[] = [];
  prizeColumns: any[] = [];

  constructor(
    private managerService: ManagerService,
  ) {}

  ngOnInit(): void {
    if (this.tournament?.tourInfo?.Prizes2.length > 0) {
      const columns = {};
      for (const item of this.tournament?.tourInfo
        ?.prizes as TournamentPrize2[]) {
        if (item.Position) {
          columns["Position"] = true;
        }
        if (item.Chips && item.Chips.Percentage) {
          columns["ChipsPercentage"] = true;
        }
        if (item.Chips && item.Chips.Amount) {
          columns["ChipsAmount"] = true;
        }
        if (item.Tickets) {
          columns["Tickets"] = true;
        }
        if (item.ExternalTickets) {
          columns["ExternalTickets"] = true;
        }
        if (item.ExternalPoints) {
          columns["Points"] = true;
        }
      }
      this.prizeColumns = Object.keys(columns);
    }
  }
  ngOnChanges(): void {
    this.managerService.viewTournament$
      .subscribe({
        next: (tournament) => {
          this.prizesData = tournament?.tourInfo?.Prizes2;
        },
      });
  }

}
